<h2 mat-dialog-title>Remove {{ user.name }} from {{ space.name }}?</h2>

<mat-dialog-content>
  User will lose access but the user will not be removed from any assigned
  tasks. Comments they made on tasks in this space will not be deleted.
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="warn" (click)="accept()">
    Remove from space
  </button>
</mat-dialog-actions>
